import {createGlobalStyle} from "styled-components";

export default createGlobalStyle`
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: 'Source Sans Pro', sans-serif;
        
        text-rendering: optimizeLegibility;
        -webkit-font-smoothing: antialiased;
      }

      body {
        /* background-color: #f6f6f6; */
        background-color: rgb(244, 244, 244);
      }
`;